import Card from "../Card/Card";
import { useDashboardData } from "../../Data/Data";
import { getCurrencySymbol } from "../../helper/formatCurrency";
import { useRestaurantConfig } from "../../utils/restaurantConfig";
import { useRestaurantDetails } from "../../context/RestaurantDetailsContext";

const Cards = () => {
  const cardsData = useDashboardData() || [];
  const { locale } = useRestaurantConfig();
  const currencySymbol = getCurrencySymbol(locale);
  const { restaurantDetails } = useRestaurantDetails() || {};
  const features = restaurantDetails?.restaurant?.features || {};

  return (
    <div>
      <div className="mb-5">
        <h2 className="font-semibold text-lg text-gray-900">Quick Stats</h2>
        <p className="text-sm text-gray-500 mt-0.5">Overview of your restaurant's performance</p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {cardsData.length > 0 ? (
          cardsData
            .filter((card) => {
              // When "User Feedback" feature is disabled in Configure,
              // hide the "Customer Rating" stat card.
              if (card?.link === "/feedback") return features?.feedback !== false;
              return true;
            })
            .map((card, id) => (
              <Card
                key={id}
                title={card.title}
                icon={card.icon}
                color={card.color}
                series={card.series}
                link={card.link}
                currencySymbol={currencySymbol}
              />
            ))
        ) : (
          <div className="col-span-full flex flex-col items-center justify-center py-12">
            <div className="animate-spin rounded-full h-7 w-7 border-b-2 border-gray-300 mb-3" />
            <p className="text-gray-400 text-sm">Loading dashboard data…</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Cards;
